import { render, staticRenderFns } from "./import-statement.vue?vue&type=template&id=8505e8b4&scoped=true&"
import script from "./import-statement.vue?vue&type=script&lang=js&"
export * from "./import-statement.vue?vue&type=script&lang=js&"
import style0 from "./import-statement.vue?vue&type=style&index=0&id=8505e8b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8505e8b4",
  null
  
)

export default component.exports